export default "__VITE_ASSET__ef0b2021__"